import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const CookieConsentContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(51, 51, 51, 0.9);
  color: white;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
    gap: 10px;
  }
`;

const CookieText = styled.p`
  margin: 0;
  font-size: 14px;
  max-width: 80%;

  @media (max-width: 768px) {
    max-width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
`;

const CookieLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
  color: #ffffff;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const AcceptButton = styled.button`
  background-color: #e4194e;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;

  &:hover {
    background-color: #c01543;
  }
`;

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem('cookieConsent');
    if (!hasAccepted) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <CookieConsentContainer>
      <CookieText>
        We use cookies to give you the best online experience. By continuing to use our site, you accept our 
        <CookieLink href="https://www.unilevernotices.com/cookie-notices/sri-lanka-english.html" target="_blank" rel="noopener noreferrer"> terms & conditions</CookieLink>.
      </CookieText>
      <ButtonContainer>
        <AcceptButton onClick={handleAccept}>Accept!</AcceptButton>
      </ButtonContainer>
    </CookieConsentContainer>
  );
};

export default CookieConsent;
